import { COLORS } from '@r1-frontend/ui-react/assets/js/constants';
import { BaseButton } from '@r1-frontend/ui-react/components/buttons/baseButton';
import InputSimple, { nameDecorator, phoneDecorator } from '@r1-frontend/ui-react/components/inputSimple';
import Popup from '@r1-frontend/ui-react/components/popups/defaultPopup';
import { FONTS } from '@r1-frontend/ui-react/tokens/fonts';
import styled from 'styled-components';

const InputPhone = phoneDecorator(InputSimple);
const InputName = nameDecorator(InputSimple);

export const Wrapper = styled(Popup)`
    padding: 40px;
    width: calc(100% - 10px) !important;
    max-width: 896px !important;
    @media (max-width: 1024px) {
        max-width: 660px !important;
    }
    @media (max-width: 700px) {
        max-width: 430px !important;
    }
    @media (max-width: 410px) {
        padding: 40px 20px;
    }
`;

export const Fields = styled.div`
    display: flex;
    width: 100%;
    justify-content: flex-start;
    align-items: flex-start;
`;

export const Name = styled(InputName)`
    display: block;
    width: 299px;
    margin-right: 16px;
    @media (max-width: 700px) {
        width: 100%;
        margin-right: 0;
    }
`;

export const Phone = styled(InputPhone)`
    display: block;
    width: 262px;
    @media (max-width: 700px) {
        width: 100%;
    }
`;

export const Buttons = styled.div`
    display: flex;
    width: 100%;
    justify-content: flex-start;
    align-items: flex-start;
    margin-bottom: 16px;
`;

export const Button = styled(BaseButton)`
   width: 262px;
    &:first-child {
        margin-right: 16px;
        width: 299px;
        @media (max-width: 700px) {
            margin-right: 0;
            margin-bottom: 16px;
            width: 100%;
        }
    }
     @media (max-width: 700px) {
        width: 100%;
    }
`;

export const Agree = styled.div`
    display: block;
    width: 100%;
    ${FONTS.M};
    color: ${COLORS.darkGrey};
    a {
        display: inline-block;
        border-bottom: 1px solid ${COLORS.darkGrey};
        color: ${COLORS.darkGrey};
    }
    @media (max-width: 700px) {
        ${FONTS.XS};
    }
`;
